import type { PayoutRescueTranslations } from "../interfaces/payoutRescue";

export const payoutRescueTranslations: PayoutRescueTranslations = {
  // Page
  page_title: "Resgate de dispersões",
  page_subtitle: "Dispersões cujo envio automático falhou: reenvie ou devolva os fundos",
  refresh_button: "Atualizar",
  refresh_aria: "Atualizar a fila",
  error_load: "Não foi possível carregar a fila de resgate.",
  error_retry: "Tentar novamente",

  // KPI strip
  kpi_pending_label: "Para resgatar",
  kpi_pending_caption: "Requer ação",
  kpi_processing_label: "Em andamento",
  kpi_processing_caption: "No banco",
  kpi_paid_today_label: "Pagas hoje",
  kpi_paid_today_caption: "Liquidadas",
  kpi_retained_label: "Valor retido",

  // Tabs
  tab_pending: "Para resgatar",
  tab_processing: "Em andamento",
  tab_history: "Histórico",

  // Filters
  filter_search_placeholder: "Buscar por ID, organização ou conceito",
  filter_org_label: "Organização",
  filter_all_orgs: "Todas as organizações",
  filter_corridor_label: "Corredor",
  filter_all_corridors: "Todos os corredores",
  filter_status_label: "Status",
  filter_all_statuses: "Todos os status",
  filter_clear: "Limpar filtros",
  export_button: "Exportar",

  // Status labels
  status_created: "Para resgatar",
  status_processing: "Processando",
  status_paid: "Paga",
  status_failed: "Falhou",
  status_cancelled: "Cancelada",
  status_reversed: "Revertida",
  status_long_created: "Requer resgate",
  status_long_processing: "Processando no banco",
  status_long_paid: "Paga",
  status_long_failed: "Rejeitada pelo banco",
  status_long_cancelled: "Cancelada",
  status_long_reversed: "Revertida",

  // Table
  table_th_age: "Antiguidade",
  table_th_org: "Organização",
  table_th_corridor: "Corredor",
  table_th_beneficiary: "Beneficiário",
  table_th_concept: "Conceito",
  table_th_net: "Líquido",
  table_th_status: "Status",
  action_review: "Revisar",
  action_view: "Ver",
  empty_pending_title: "Tudo em dia",
  empty_pending_description: "Nenhuma dispersão precisa de resgate neste momento.",
  empty_processing_title: "Nada em andamento",
  empty_processing_description: "Não há dispersões aguardando confirmação do banco.",
  empty_history_title: "Sem histórico",
  empty_history_description: "Ainda não há dispersões finalizadas.",
  empty_filtered_description: "Não há dispersões para os filtros selecionados.",
  queue_truncated: "Mostrando as primeiras {{shown}} de {{total}} — use os filtros para refinar a lista.",
  pagination_summary: "Mostrando {{from}}–{{to}} de {{total}}",
  footer_order_pending: "Ordem: mais antigas primeiro",

  // Drawer
  drawer_title: "Dispersão {{id}}",
  drawer_rescue_alert:
    "O envio automático não foi concluído. Reenvie após corrigir a configuração, ou cancele para devolver os fundos.",
  drawer_org: "Organização",
  drawer_corridor: "Corredor",
  drawer_beneficiary: "Beneficiário",
  drawer_destination_unavailable: "Dados do destino não disponíveis nesta visualização",
  drawer_concept: "Conceito",
  drawer_reference: "Referência",
  drawer_created: "Criada",
  drawer_failure_reason: "Motivo",
  copy_aria: "Copiar",
  copy_success: "Copiado para a área de transferência",
  destination_label_clabe: "CLABE",
  destination_label_pix: "Chave PIX ({{type}})",
  destination_label_cbu_cvu: "Conta {{type}}",

  // Breakdown
  breakdown_title: "Detalhamento",
  breakdown_gross: "Bruto (debitado do cliente)",
  breakdown_fees: "Taxas",
  breakdown_fee_coloca: "Taxa Coloca",
  breakdown_fee_network: "Custo de rede (incluído)",
  breakdown_tax_absorbed: "assumido pela Coloca",
  breakdown_economic_model: "Modelo econômico",
  breakdown_net: "Líquido (o beneficiário recebe)",

  // Timeline
  timeline_title: "Linha do tempo · auditoria",
  timeline_source_staff: "Equipe Coloca",
  timeline_source_network: "Confirmação da rede bancária",
  timeline_source_system: "Sistema",
  timeline_by: "por {{actor}}",
  timeline_error: "Não foi possível carregar a linha do tempo.",

  // Drawer actions
  actions_cancel: "Cancelar e devolver fundos",
  actions_retry: "Reenviar",
  processing_note: "No banco — a confirmação chega em minutos. Sem ações disponíveis.",
  reconcile_soon: "Reconciliar (em breve)",
  terminal_note: "Operação finalizada — somente leitura.",

  // Retry modal
  retry_title: "Reenviar dispersão",
  retry_warning: "Esta ação envia dinheiro real e é irreversível. Revise os dados antes de confirmar.",
  retry_summary_beneficiary: "Beneficiário",
  retry_summary_corridor: "Corredor",
  retry_summary_org: "Organização",
  retry_sends_label: "Enviado ao beneficiário",
  retry_debits_caption: "{{gross}} são debitados do cliente (taxas incluídas)",
  retry_confirm_check: "Confirmo que o beneficiário, o destino e o valor estão corretos.",
  retry_confirm_check_no_destination: "Confirmo que a organização, o corredor e o valor estão corretos.",
  retry_cancel: "Cancelar",
  retry_arming: "Revise o resumo…",
  retry_confirm: "Confirmar envio",
  retry_sending_title: "Enviando ao banco…",
  retry_sending_caption: "Contatando a rede {{corridor}}. Não feche esta janela.",
  retry_done_processing_title: "Enviada ao banco",
  retry_done_processing_msg: "Está a caminho. A confirmação do banco chega em minutos.",
  retry_done_paid_title: "Paga!",
  retry_done_paid_msg: "O banco liquidou a transferência imediatamente. O beneficiário já recebeu os fundos.",
  retry_done_failed_title: "Rejeitada pelo banco",
  retry_done_failed_msg:
    "A rede rejeitou a operação. Os fundos voltaram ao saldo disponível do cliente. Não pode ser reenviada.",
  retry_done_stuck_title: "Não foi possível enviar",
  retry_done_stuck_msg:
    "O corredor não está configurado. Contate a plataforma e tente novamente quando estiver resolvido. A dispersão continua pendente de resgate.",
  retry_done_race_title: "Já foi processada",
  retry_done_race_msg: "Outro operador processou esta dispersão. Ela foi atualizada com o status atual.",
  retry_done_button: "Concluído",

  // Cancel modal
  cancel_title: "Cancelar dispersão",
  cancel_body:
    "Os fundos reservados ({{gross}}) voltam ao saldo disponível de {{org}}. A dispersão ficará como Cancelada.",
  cancel_reason_label: "Motivo (opcional)",
  cancel_reason_placeholder: "Ex. dados do beneficiário inválidos",
  cancel_back: "Voltar",
  cancel_confirm: "Cancelar e devolver fundos",
  cancel_error: "Não foi possível cancelar a dispersão.",

  // Toasts
  toast_retry_processing: "Enviada — aguardando confirmação do banco",
  toast_retry_paid: "Dispersão paga",
  toast_retry_failed: "Rejeitada pelo banco — fundos devolvidos",
  toast_retry_stuck: "Não foi possível enviar — corredor não configurado",
  toast_race: "Já foi processada por outro operador",
  toast_cancelled: "Fundos devolvidos ao cliente",
};
